
// Admin
  export const ADMIN_BONDS_ACTIONS = {
    // list
    BONDS_LIST_REQUEST: "ADMIN_BONDS_LIST_REQUEST",
    BONDS_LIST_RESPONSE: "ADMIN_BONDS_LIST_RESPONSE",
    BONDS_LIST_ERROR: "ADMIN_BONDS_LIST_ERROR",

    // create
    BONDS_REQUEST: "BONDS_REQUEST",
    BONDS_RESPONSE: "BONDS_RESPONSE",
    BONDS_ERROR: "BONDS_ERROR",

    // update
    BONDS_EDIT_REQUEST: "BONDS_EDIT_REQUEST",
    BONDS_EDIT_RESPONSE: "BONDS_EDIT_RESPONSE",
    BONDS_EDIT_ERROR: "BONDS_EDIT_ERROR",

    // delete
    BONDS_DELETE_REQUEST: "BONDS_DELETE_REQUEST",
    BONDS_DELETE_RESPONSE: "BONDS_DELETE_RESPONSE",
    BONDS_DELETE_ERROR: "BONDS_DELETE_ERROR",
  };
  